import {EntityHistory} from "./EntityHistory";
import {findEntityById, toFullEntityResult} from "./helpers/toFullEntityResult";
import {DriverId} from "./nominalTypes/DriverId";
import {AllPermitsResult} from "./types/AllPermitsResult";
import {DriverResult} from "./types/DriverResult";
import {FullEntityRelation} from "./types/EntityRelation";
import {PermitEntityResult, PermitFullEntityResult} from "./types/PermitEntityResult";

function createEmptyDriver(driverId: DriverId): DriverResult {
	return {
		id: driverId,
		fullName: driverId,
		licenseNumber: "",
		attachments: [],
		customData: []
	}
}

class Drivers {
	static get(permits: AllPermitsResult, id: DriverId): DriverResult {
		return findEntityById(permits.drivers, id, createEmptyDriver);
	}

	static getAll(permits: AllPermitsResult, ids: DriverId[]): DriverResult[] {
		return ids.map(id => this.get(permits, id));
	}

	static getChanged(permits: AllPermitsResult, driver: PermitEntityResult<DriverId>[]): FullEntityRelation<DriverId, DriverResult> | undefined {
		const c = EntityHistory.changed(driver);
		if (!c) {
			return;
		}

		const {original, changed} = c;
		return {
			original: toFullEntityResult(permits.drivers, original, createEmptyDriver),
			changed: changed && toFullEntityResult(permits.drivers, changed, createEmptyDriver)
		};
	}

	static getValid(permits: AllPermitsResult, driver: PermitEntityResult<DriverId>[]): PermitFullEntityResult<DriverId, DriverResult> | undefined {
		const e = EntityHistory.approvedOrDefault(driver);
		if (e == null) {
			return;
		}
		return toFullEntityResult(permits.drivers, e, createEmptyDriver);
	}
}

export {Drivers};
